import request from '../util/request';

function setUrlParam(data) {
  let _str = '';
  for (let i in data) {
    if (!isNull(data[i])) {
      _str += i + '=' + encodeURIComponent(data[i]) + '&';
    }
  }
  return '?' + _str.substring(0, _str.length - 1);
}

function isNull(e) {
  let _ = String(e);
  return (_ === 'null' || _ === 'NaN' || _ === 'undefined' || _.length === 0);
}


const api = {
  // 新增
  addAppointment(data){
    return request({
      url: '/appointment/addAppointment',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
 
  queryContentById(data) {
    return request({
      url: '/base/queryContentById?contentId='+data,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'GET',

    })
  },
  // 
  listBanner(data) {
    return request({
      url: '/base/listBanner',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getUserInfo(data) {
    return request({
      url: '/user/getUserInfo',
      method: 'POST',
      // data:data,
    })
  },
  queryContentByCode(data) {
    return request({
      url: '/base/queryContentByCode?contentCode='+data,
      method: 'GET',
      // data:data,
    })
  },
  listContent(data) {
    return request({
      url: '/base/listContent',
      method: 'POST',
      data:data,
    })
  },
  listVideo(data) {
    return request({
      url: '/base/listVideo',
      method: 'POST',
      data:data,
    })
  },
  listTeacher(data) {
    return request({
      url: '/base/listTeacher',
      method: 'POST',
      data:data,
    })
  },
  queryTeacherById(data) {
    return request({
      url: '/base/queryTeacherById?teacherId='+data,
      method: 'GET',
    })
  },
  loginByWechat(data) {
    return request({
      url: '/loginByWechat',
      method: 'POST',
      data:data,
    })
  },
  listCommodityType(data) {
    return request({
      url: '/commodity/listCommodityType'+setUrlParam(data),
      method: 'POST',
      data:data,
    })
  },
  listCommoditys(data) {
    return request({
      url: '/commodity/listCommodity',
      method: 'POST',
      data:data,
    })
  },
  getCommodity(data) {
    return request({
      url: '/commodity/getCommodity',
      method: 'POST',
      data:data,
    })
  },
  listCommodityRecommend(data) {
    return request({
      url: '/commodity/listCommodityRecommend',
      method: 'POST',
      data:data,
    })
  },
  getCommodityStock(data) {
    return request({
      url: '/commodity/getCommodityStock'+setUrlParam(data),
      method: 'POST',
      data:data,
    })
  },
  createOrder(data) {
    return request({
      url: '/order/createOrder',
      method: 'POST',
      data:data,
    })
  },
  listLinkmen(data) {
    return request({
      url: '/user/listLinkmen'+setUrlParam(data),
      method: 'POST',
      data:data,
    })
  },
  listUserApplicant(data) {
    return request({
      url: '/user/listUserApplicant'+setUrlParam(data),
      method: 'POST',
      data:data,
    })
  },
  delLinkmen(data) {
    return request({
      url: '/user/delLinkmen',
      method: 'POST',
      data:data,
    })
  },
  delUserApplicant(data) {
    return request({
      url: '/user/delUserApplicant',
      method: 'POST',
      data:data,
    })
  },
  orderQuery(data) {
    return request({
      url: '/order/orderQuery'+setUrlParam(data),
      method: 'POST',
      data:data,
    })
  },
  orderInfoQuery(data) {
    return request({
      url: '/order/orderInfoQuery'+setUrlParam(data),
      method: 'POST',
      data:data,
    })
  },
  payOrder(data) {
    return request({
      url: '/order/payOrder',
      method: 'POST',
      data:data,
    })
  },
  listOrder(data) {
    return request({
      url: '/order/listOrder',
      method: 'POST',
      data:data,
    })
  },
  cancelOrder(data) {
    return request({
      url: '/refundOrder/cancelOrder',
      method: 'POST',
      data:data,
    })
  },
  refundApply(data) {//申请退款
    return request({
      url: '/refundOrder/refundApply',
      method: 'POST',
      data:data,
    })
  },
  delOrder(data) {//删除订单
    return request({
      url: '/order/delOrder',
      method: 'POST',
      data:data,
    })
  },
  listSchool() {//学校列表
    return request({
      url: '/base/listSchool',
      method: 'GET',
    })
  },
  login() {//学校列表
    return request({
      url: '/api/user/login',
      method: 'POST',
    })
  },
};

export default api;
